"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addHoursToDate = addHoursToDate;
exports.addDaysToDate = addDaysToDate;
exports.addMonthsToDate = addMonthsToDate;
exports.addYearsToDate = addYearsToDate;
function addHoursToDate(date, hours) {
    const result = new Date(date);
    result.setHours(result.getHours() + hours);
    return result;
}
/** Negative numbers are supported as well */
function addDaysToDate(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
function addMonthsToDate(date, months) {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
}
function addYearsToDate(date, years) {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
}
